import type { IconName } from "../../icon-name";
import type { TranslatableType } from "../../translations/translation";
import type { AgendaColumnType } from "./agenda-column-type";
import { agendaColumnZodEnum } from "./agenda-column-type";
import type { AgendaColumnSettings } from "./agenda-column.settings";

const agendaColumn: Record<AgendaColumnType, AgendaColumnType> = {
    upcoming: "upcoming",
    active: "active",
    unhandled: "unhandled",
    fulfilled: "fulfilled",
};
const agendaColumnMeta: Record<
    AgendaColumnType,
    {
        label: {
            today: TranslatableType;
            past: TranslatableType;
            future: TranslatableType;
        };
        iconName?: IconName;
        defaultSettings: AgendaColumnSettings;
    }
> = {
    upcoming: {
        label: {
            past: {
                sv: "Startade",
                en: "Started",
            },
            today: {
                sv: "Startar",
                en: "Upcoming",
            },
            future: {
                sv: "Startar",
                en: "Upcoming",
            },
        },
        iconName: "fa-clock",
        defaultSettings: {
            showBlocked: false,
            showDropIns: false,
            showExtras: true,
        },
    },
    active: {
        label: {
            past: {
                sv: "Var aktiva",
                en: "Was active",
            },
            today: {
                sv: "Aktiva",
                en: "Active",
            },
            future: {
                sv: "Aktiva",
                en: "Active",
            },
        },
        iconName: "fa-running",
        defaultSettings: {
            showBlocked: true,
            showDropIns: true,
            showExtras: true,
        },
    },
    fulfilled: {
        label: {
            past: {
                sv: "Klara",
                en: "Completed",
            },
            today: {
                sv: "Klara",
                en: "Completed",
            },
            future: {
                sv: "Avslutas",
                en: "To be completed",
            },
        },
        iconName: "fa-check",
        defaultSettings: {
            showBlocked: false,
            showDropIns: false,
            showExtras: true,
        },
    },
    unhandled: {
        label: {
            past: null,
            today: {
                sv: "Ej hanterade",
                en: "Unhandled",
            },
            future: null,
        },
        iconName: "fa-exclamation-triangle",
        defaultSettings: {
            showBlocked: false,
            showDropIns: false,
            showExtras: true,
        },
    },
};

export { agendaColumn, agendaColumnMeta, agendaColumnZodEnum };
export type { AgendaColumnType };
